import { Profiles } from 'types/user';

export enum EDDR_MODULES {
  EDDR_OVERVIEW = 'EDDR_OVERVIEW',
  EDDR_OPERATIONS_LOG = 'EDDR_OPERATIONS_LOG',
  EDDR_FLUIDS = 'EDDR_FLUIDS',
  EDDR_BHA = 'EDDR_BHA',
  EDDR_TRAJECTORY = 'EDDR_TRAJECTORY',
  EDDR_SAFETY = 'EDDR_SAFETY',
  EDDR_WELL_ACTIVITY_HISTORY = 'EDDR_WELL_ACTIVITY_HISTORY',
}

export const eddrModules = Object.values(EDDR_MODULES);

export const allowedEddrModules = {
  [Profiles.NO_ACCESS]: [] as EDDR_MODULES[],
  [Profiles.PO]: eddrModules,
  [Profiles.DRILLX]: eddrModules,
  [Profiles.INTERNAL]: eddrModules,
  [Profiles.EXTERNAL]: eddrModules,
  [Profiles.REPORTING_PARTNER]: eddrModules,
  [Profiles.REPORTING_PARTNER_WITH_COSTS]: eddrModules,
};
